import React, { createContext, useMemo } from "react";
import { createApiClient } from "../../services/apiClient";

export const ApiContext = createContext(null);

const STORAGE_TOKEN = "cc_token";

export const ApiProvider = ({ children }) => {
  const api = useMemo(() => {
    const client = createApiClient();
    const token = localStorage.getItem(STORAGE_TOKEN);
    if (token) {
      client.setToken(token);
    }
    return client;
  }, []);

  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
};
